import { Component } from '@angular/core';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BackgroundVerificationService } from '../../../Model/BackgroundVerification/background-verification.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-bgvcheck-list-form',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent],
  templateUrl: './bgvcheck-list-form.component.html',
  styleUrl: './bgvcheck-list-form.component.scss'
})
export class BGVCheckListFormComponent {
  isDisabled: boolean = false;
  CheckList = {
    SelectType: 'U',
    ESS_BGVCheckListMasterId: null as any,
    CheckListName: null,
    InitiationDays: null,
  }

  constructor(
    private backgroundVerification: BackgroundVerificationService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private toast: ToastService,
    private router: Router,
    protected tooltip: TooltipService,
    protected common: CommonService,
  ) {
    this.route.params.subscribe(params => this.CheckList.ESS_BGVCheckListMasterId = parseInt(params['id']));
    //this.common.getPageRights();
    this.common.PageRight.IsAdd = true;
    this.common.PageRight.IsEdit = true;

  }

  ngOnInit(): void {
    if (this.CheckList.ESS_BGVCheckListMasterId > 0) {
      this.ESS_BGVFillCombo('S');
    } else {
      this.close();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.CheckList.InitiationDays != null && this.CheckList.InitiationDays != '' && this.CheckList.InitiationDays >= 0 && this.CheckList.InitiationDays <= 999) {
        this.ESS_BGVCheckListUpdate();
      } else {
        this.toast.show({ message: 'Day must be between 0 to 999', type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_BGVFillCombo(SelectType: string) {
    this.isDisabled = true;
    this.backgroundVerification.ESS_BGVFillCombo({ SelectType: SelectType, ESS_BGVCheckListMasterID: this.CheckList.ESS_BGVCheckListMasterId, ESS_BGVApiMasterID: 0 }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (SelectType == 'S') {
            this.CheckList.ESS_BGVCheckListMasterId = response.Table[0].ESS_BGVCheckListMasterID;
            this.CheckList.CheckListName = response.Table[0].CheckListName;
            this.CheckList.InitiationDays = response.Table[0].InitiationDays;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_BGVCheckListUpdate() {
    //await this.common.getPageRights();
    if (this.common.PageRight.IsEdit) {
      this.isDisabled = true;
      this.backgroundVerification.ESS_BGVCheckListUpdate(this.CheckList).subscribe({
        next: (response) => {
          if (response.Error_Code == '788') {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              if (result) {
                this.close();
              }
            });
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  close() {
    this.router.navigate(['/master/bgvchecklist/']);
  }
}
